import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

// import components
import ProductionFormContainer from './Components/ProductionFormContainer/ProductionFormContainer.js';
import DropDown from './Components/DropDown/DropDown.js';

// Ustra - for app.state management
import Ustra from './Ustra.js';

// conjure form class
import ConjureForm from './ConjureForm/ConjureForm.js';

// images
import __img_ConjureLogo from './Images/mc_1200.png';

// =============================================================================
// Constants
// =============================================================================

import __sampleForm_YC from './SampleForms/YC_Form.json';
import __sampleForm_SQLite from './SampleForms/SQLite_Form.json';
import __sampleForm_Twitch from './SampleForms/Twitch_Form.json';

const __formLookup = {
  "SQLite": __sampleForm_SQLite,
  "YC Application": __sampleForm_YC,
  "Twitch": __sampleForm_Twitch
};

let __formOptions = [];
for (let key in __formLookup) {
  __formOptions.push(key);
}




// =============================================================================
// Initialize Ustra & ConjureForm
// =============================================================================

//.path tags
const PT_conjureForm = "conjureForm";
const PT_formOutput = "formOutput";
const PT_currentPageIndex = "currentPageIndex";

const PT_selectedFormName = "selectedFormName";

// what App.state will look like
let dataSkeleton = {
  [PT_conjureForm]: new ConjureForm(),
  [PT_formOutput]: {},
  [PT_currentPageIndex]: 0,

  [PT_selectedFormName]: __formOptions[0]
}

// initialize Ustra
var ustra = new Ustra(dataSkeleton);

// =============================================================================
// App
// =============================================================================

class App extends Component {

  constructor() {
    super();
    this.state = {
      truth: ustra.get_truth()
    };

    let conjureForm = new ConjureForm();
    let formName = this.state.truth[PT_selectedFormName];
    let formToLoad = __formLookup[formName];
    conjureForm.loadConjureForm(formToLoad);
    this.saveConjureForm(conjureForm);
  }

  // Update USTRA --------------------------------------------------------------
  /*
    Functions for updating information
      -> pass updates to ustra, use results to update app.state
  */

  update = (value, path_tag) => {
    let new_state = ustra.update(value, path_tag);
    this.setState({
      truth: new_state
    });
  }

  // takes an updated conjureForm and saves it to ustra
  saveConjureForm = (conjureForm) => {
    let conjureFormOutput = conjureForm.getFormOutputObject();
    this.update(conjureForm, PT_conjureForm);
    this.update(conjureFormOutput, PT_formOutput);
  }

  // ConjureForm in Production -------------------------------------------------
  /*
    Functions that get passed to ConjureForms so that they can fill out the result object properly when a user answers the form
  */

  onInput_answerFormQuestion = (itemID, value) => {
    let formOutput = this.state.truth[PT_formOutput];
    formOutput.answerInputQuestion(value, itemID);
    this.update(formOutput, PT_formOutput);
  }

  onClick_answerMultipleChoiceQuestion = (value, itemID) => {
    let formOutput = this.state.truth[PT_formOutput];
    formOutput.answerMultipleChoiceQuestion(value, itemID);
    this.update(formOutput, PT_formOutput);
  }

  onClick_addNewSubformToArray = (arrayID) => {
    let formOutput = this.state.truth[PT_formOutput];
    formOutput.declareNewArrayItem(arrayID);
    this.update(formOutput, PT_formOutput);
  }

  onClick_removeSubformFromArray = (arrayID, subformIndex) => {
    let formOutput = this.state.truth[PT_formOutput];
    formOutput.removeArrayItem(arrayID, subformIndex);
    this.update(formOutput, PT_formOutput);
  }


  onClick_moveToPage = (moveType) => {
    let newPageNum = this.state.truth[PT_currentPageIndex];
    if (moveType === "next") {
      newPageNum += 1;
    } else if (moveType === "prev" && newPageNum > 0){
      newPageNum -= 1;
    }
    this.update(newPageNum, PT_currentPageIndex);
  }


  // Switching Forms -----------------------------------------------------------

  onClick_selectForm = (newFormName) => {
    if ((newFormName !== this.state.truth[PT_selectedFormName]) && (newFormName in __formLookup)) {
      this.update(newFormName, PT_selectedFormName);
      this.update(0, PT_currentPageIndex);

      let newConjureForm = new ConjureForm();
      let formToLoad = __formLookup[newFormName];
      newConjureForm.loadConjureForm(formToLoad);
      this.saveConjureForm(newConjureForm);
    }
  }

  // Render --------------------------------------------------------------------


  // renders the selected form and its output
  renderForm = () => {

    let truth = this.state.truth;
    let conjureForm = truth[PT_conjureForm];
    let formOutput = truth[PT_formOutput];

    return (
      <div id="page_item_form_container">
        <div className="form_container">
          <div className="row_space_between">
            <h1 className="title">Survey</h1>
            <div style={{'width': '200px', 'height': '50px'}}>
              <DropDown
                selected={truth[PT_selectedFormName]}
                options={__formOptions}
                onClick_selectOption={this.onClick_selectForm}
              />
            </div>
          </div>
          <div id="output_object_container">
            <ProductionFormContainer
              conjureForm={conjureForm}
              formOutput={formOutput}
              currentPageIndex={truth[PT_currentPageIndex]}
              onClick_deselectItem={() => this.onClick_selectFormSection(false)}
              onInput_answerFormQuestion={this.onInput_answerFormQuestion}
              onClick_answerMultipleChoiceQuestion={this.onClick_answerMultipleChoiceQuestion}
              onClick_addNewSubformToArray={this.onClick_addNewSubformToArray}
              onClick_removeSubformFromArray={this.onClick_removeSubformFromArray}
              onClick_moveToPage={this.onClick_moveToPage}
            />
          </div>

        </div>

        <div className="form_container">
          <h1 className="title">Output</h1>
          <div id="output_object_container">
            {formOutput.render(true)}
          </div>
        </div>
      </div>
    )
  }



  renderDemoDescription = () => {
    return (
      <div className="section_container">
        <img id="conjure_logo" src={__img_ConjureLogo}/>
        <h1 id="demo_title">Conjure UX Demo</h1>
        <p className="demo_description">This demo shows off some sample Conjure surveys.</p>
        <p className="demo_description">While these surveys are not hooked up to code generators, this gives a pretty good feel for how Conjure feels like to use. </p>
        <p className="demo_description">The survey-building tool lets you build highly expressive forms, you can try it <a href="https://conjure.netlify.com" target="__blank">here</a>.</p>
        <p className="demo_description"><a href="https://github.com/darrendawson/ConjureFormMaker">Here</a> is the source code for the forms, I'm working on adding it to NPM.</p>
      </div>
    );
  }



  renderFooter = () => {
    return (
      <div>
        <div style={{'width': '100%', 'height': '2px', 'background-color': '#cccccc', 'margin': '30px 0px 5px 0px'}}></div>
        <p style={{'text-align': 'right', 'margin': '0px 0px 30px 0px', 'font-size': '1.2em'}}>Made by <a href="https://thedarrendawson.com" target="__blank">Darren Dawson</a></p>
      </div>
    );
  }

  render() {
    return (
      <div id="App">
        <div id="content_column">
          {this.renderDemoDescription()}
          <h1 className="section_title">Example Surveys</h1>
          {this.renderForm()}
          {this.renderFooter()}
        </div>
      </div>
    );
  }

}

export default App;
